import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import BackComponent from 'screens/back';
import { Table, Pagination, Tooltip, Input, CheckboxTable, DatePicker, Select, Modal } from 'components';
import { ExcelIcon, TrashIcon, EditIcon, CleanIcon, AddWhiteIcon, TrashWhiteIcon, ViewIcon, PrintIcon, OperatorsIcon, ConfirmIcon, StarIcon, CanceledIcon, MoneyIcon, CopyIcon } from 'assets/icons';
import { Globals, Constants, Colors, checkPermission, Print } from 'utils';
import { ReportService } from 'services';
import moment from 'moment';
import queryString from 'query-string';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {
	search: '',
	since: '',
	until: '',
	type_id: '',
	search_operators: ''
}

declare var window: any;

class Quotes extends React.Component<Props> {

	timer: any = undefined;

	state = {
		form: INITIAL_STATE,
		page: 1,
		last_page: 1,
		data: [],
		header: [
			'Nº Orden',
			'Cliente',
			'Teléfono',
			'Tipo',
			'Fecha',
			'Servicio',
			'Dirección',
			'Precio',
			'Método de Pago',
			'Superficie',
			'Talentos',
			'Origen'
		],
		item: null,
		quote_types: [],
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Reporte de Servicios de Limpieza',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.load();
	}

	load = async (withoutLoading: boolean = false,callback = () => {}) => {
		const res: any = await ReportService.admin.getServices({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
			since: this.state.form.since && moment(this.state.form.since).format('YYYY-MM-DD'),
			until: this.state.form.until && moment(this.state.form.until).format('YYYY-MM-DD'),
		});
		await this.setState({
			data: res.quotes.rows,
			last_page: res.quotes.count,
			quote_types: res.quote_types
		},() => callback());
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(true));
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	getColor = (service: any) => {
		switch(service.status) {
			case Constants.QUOTE_STATUS.FINISH:
				return Colors.green;
			break;

			case Constants.QUOTE_STATUS.PENDING:
				return Colors.danger;
			break;

			case Constants.QUOTE_STATUS.IN_PROGRESS:
				return Colors.yellow;
			break;

			case Constants.QUOTE_STATUS.CANCELLED:
				return Colors.blue;
			break;
		}
	}

	getPaymentColor = (service: any) => {
		if (service.payment_method_id == Constants.PAYMENT_METHODS.CORPORATE) {
			return Colors.corporate;
		}

		switch(service.status_payment) {
			case Constants.QUOTE_PAYMENT_STATUS.PENDING:
				return Colors.yellow;
			break;

			case Constants.QUOTE_PAYMENT_STATUS.REJECTED:
				return Colors.danger;
			break;

			case Constants.QUOTE_PAYMENT_STATUS.APPROVED:
				return Colors.green;
			break;
		}
	}

	download = async () => {
		const res: any = await ReportService.admin.downloadServices({
			...this.state.form,
			since: this.state.form.since && moment(this.state.form.since).format('YYYY-MM-DD'),
			until: this.state.form.until && moment(this.state.form.until).format('YYYY-MM-DD'),
		});
		if (window.webkit && window.webkit.messageHandlers) {
			const message = 'open_url';
			const sendToNative = {
				message,
				url: Constants.BASE_STORAGE + res.url
			}
			const stringifiedMessageObj = JSON.stringify(sendToNative);
	        window.webkit.messageHandlers.cordova_iab.postMessage(stringifiedMessageObj);
	    }
	    else {
	    	Print(Constants.BASE_STORAGE + res.url);
	    }
	}
	
	render() {
		return (
			<div id="admin-reports-services">
				<BackComponent />

				<div className="row row-filter">
					<div className="col-md-10">
						<div className="row">
							<div className="row col-md-10">
								<div className="col-md-4">
									<Input
										searchLeft
										value={ this.state.form.search }
										name="search"
										placeholder="Buscar por Cliente"
										className="input-table"
										onSubmit={ () => this.load() }
										onChange={ (e: any) => {
											clearTimeout(this.timer);
											this.timer = setTimeout(() => {
												this.load(true);
											},1000);
											this.change(e); 
										} } />
								</div>
								<div className="col-md-4">
									<Select
										placeholder="Tipo"
										name="type_id"
										onChange={ (e: any) => this.change(e,() => {
											this.load(true);
										}) }
										value={ this.state.form.type_id }
										options={ this.state.quote_types?.map((item: any) => {
											return {
												value: item.id,
												label: item.name
											}
										}) } />
								</div>
								<div className="col-md-4">
									<Input
										searchLeft
										value={ this.state.form.search_operators }
										name="search_operators"
										placeholder="Buscar por Talento"
										className="input-table"
										onSubmit={ () => this.load() }
										onChange={ (e: any) => {
											clearTimeout(this.timer);
											this.timer = setTimeout(() => {
												this.load(true);
											},1000);
											this.change(e); 
										} } />
								</div>
								<div className="col-md-4">
									<DatePicker
										placeholder="Desde"
										onChange={ (text: string) => {
											this.change({
												target: {
													value: text,
													name: 'since'
												}
											},() => this.load(true));
										} }
										value={ this.state.form.since }
									/>
								</div>
								<div className="col-md-4">
									<DatePicker
										placeholder="Hasta"
										onChange={ (text: string) => {
											this.change({
												target: {
													value: text,
													name: 'until'
												}
											},() => this.load(true));
										} }
										value={ this.state.form.until }
									/>
								</div>
							</div>
							<div className="col-md-2">
								{
									this.state.form != INITIAL_STATE && (
										<button className="btn btn-clean" onClick={ () => this.reset() }>
											<img src={ CleanIcon } />
										</button>
									)
								}
							</div>
						</div>
					</div>
					<div className="col-md-2 text-right">
						<button className="btn btn-add btn-excel" onClick={ () => this.download() }>
							Descargar
							<img src={ ExcelIcon } />
						</button>
					</div>
				</div>

				<Table data={ this.state.data.length } header={ this.state.header }>
					{ this.state.data.map((i: any,index: number) => {
						return (
							<tr key={ index }>
								<td>{ i.number }</td>
								<td>{ i.user?.full_name || '-' }</td>
								<td>{ i.user?.phone || '-' }</td>
								<td>{ i.service?.type_id == Constants.SERVICE_TYPES.CLEAN ? i.type?.name : '-' }</td>
								<td className={ i.type_id == Constants.QUOTE_TYPES.URGENT ? 'urgent' : '' }>{ i.type_id == Constants.QUOTE_TYPES.URGENT ? ('Urgente ' + moment(i.date).format('DD/MM/YYYY')) : moment(i.date).format('DD/MM/YYYY') } { ' ' }
									{ moment(i.journey?.since,'HH:mm:ss').format('hh:mm A') } - { moment(i.journey?.until,'HH:mm:ss').format('hh:mm A') }
								</td>
								<td>{ i.service?.name }</td>
								<td>{ i.city }</td>
								<td style={{ whiteSpace: 'nowrap' }}>{ Globals.formatMiles(i.price) }</td>
								<td>{ i.payment_method?.name || '-' }</td>
								<td style={{ whiteSpace: 'nowrap' }}>{ i.area }</td>
								<td className="bold">{ i.operators?.map((i: any) => i?.operator?.full_name).join(', ') }</td>
								<td>{ i.origin_text }</td>
							</tr>
						)
					}) }
				</Table>

				<Pagination 
					pages={ this.state.last_page } 
					active={ this.state.page }
					onChange={ async (page: number) => {
						await this.setState({
							page: page
						});
						this.load();
					} } />
			</div>
		)
	}
}

export default connect()(Quotes);